import { useState, useEffect } from 'react';

/**
 * Hook that returns true if the screen width is less than the specified breakpoint.
 * Defaults to 1024px (Tailwind's 'lg' breakpoint), which typically covers Mobile and Tablet.
 *
 * @param {number} breakpoint The width in pixels to check against.
 * @returns {boolean} True if the screen width is less than the breakpoint.
 */
export default function useIsMobile(breakpoint = 1024) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    const isSmallScreen = window.innerWidth < breakpoint;
    const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
    return isSmallScreen || isTouchDevice;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const query = window.matchMedia(`(max-width: ${breakpoint - 1}px), (pointer: coarse)`);

    const handleChange = () => {
      setIsMobile(query.matches);
    };

    // Modern browsers
    query.addEventListener('change', handleChange);
    return () => query.removeEventListener('change', handleChange);
  }, [breakpoint]);

  return isMobile;
}
